/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
   providedIn: 'root'
})
export class AlertApiConfiguration {
   rootUrl: string = '';
}

/**
 * Parameters for `AlertApiModule.forRoot()`
 */
export interface AlertApiConfigurationParams {
   rootUrl?: string;
}
